import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    connectorDiv: {
        height: "58vh"
    },
    connectortxt: {
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        color: "#091E42",
        paddingTop: "77px",
        margin: "18px 0px",
    },
    connectorButton: {
        fontFamily: 'Roboto',
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "22px",
        textAlign: "center",
        color: "#FFFFFF",
        padding: "10px 20px",
        background: "linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)",
        borderRadius: "6px",
        border: "none",
        cursor: "pointer",
        [theme.breakpoints.down('sm')]: {
            width: "100%",
        }

    },
    ConnectorButtonsDiv: {
        display: "flex",
        [theme.breakpoints.down('sm')]: {
            display: "block"
        }
    },
    connectorButton2: {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "22px",
        textAlign: "center",
        color: "#824ED2",
        padding: "10px 20px",
        border: "1px solid #824ED2",
        borderRadius: "6px",
        cursor: "pointer",
        [theme.breakpoints.down('sm')]: {
            width: "100%",
        }
    },
    orText: {
        fontWeight: 500,
        fontSize: "20px",
        lineHeight: "26px",
        textAlign: "center",
        letterSpacing: "-0.0014em",
        color: "#824ED2",
        display: "flex",
        alignItems: "center",
        margin: "0px 20px 0px 20px",
        [theme.breakpoints.down('sm')]: {
            width: "100%",
            justifyContent:"center",
            padding:"13px 0px 15px 0px"
        }
    }
}))